import { ConversationService } from "~/services/conversation/conversation.service";
import { JWTService } from "~/services/jwt/jwt.service";
import { PresetAssociationService } from "~/services/preset-asso/preset-asso.service";
import { PresetService } from "~/services/preset/preset.service";
import { WorkflowService } from "~/services/workflow/workflow.service";
import { ModelService } from "~/services/model/model.service";
import { QuotaService } from "~/services/quota/quota.service";

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      services: {
        presetController: (configService = {}) => new PresetService(useApi, configService),
        conversationController: (configService = {}) => new ConversationService(useApi, configService),
        presetAssoController: (configService = {}) => new PresetAssociationService(useApi, configService),
        jwtController: (configService = {}) => new JWTService(useApiLogin, configService),
        workflowController: (configService = {}) => new WorkflowService(useApi, configService),
        modelController: (configService = {}) => new ModelService(useApi, configService),
        quotaController: (configService = {}) => new QuotaService(useApi, configService),
      }
    }
  }
});
